export default __webpack_public_path__ + "static/media/kslot_banner.162cc8bf.png";